import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { cloturerpaie, dupliquerpaie, getPaie, getinfovirement, getlesmoisdupaie } from '../../../Services/paie/paie';
import { Accordion } from 'react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import { getEntrepriseByCode, getExercice } from '../../../Services/Pointeuse/EntrepriseApi';
import { getuser_personnel, getuser_personnel_actif, getUsersByCode } from '../../../Services/Pointeuse/UsersApi';
import ImageComponent from '../../Styles/ImageComponent';
import { t } from "i18next";
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { filterUserByWord } from '../../../Utils/SortObject';
import { FaCopy } from "react-icons/fa";
import OrdreVirement from '../files/OrdreVirement';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { IoIosCloseCircle } from "react-icons/io";

import { PDFViewer } from '@react-pdf/renderer';
import { formatFloat } from '../../../Utils/helper';
import Journalpaie from '../files/Journalpaie';

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function AccueilPaie() {
  const history = useHistory();
  const [groupedData, setGroupedData] = useState([]);
  const listmois = ['Janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre', 'prime', '13eme'];
  const mois = ['Janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre']
  const [exercice, setExercice] = useState([]);
  const [exercice_selectionne, setexercice_selectionne] = useState();
  const [exercice_precedent, setexercice_precedent] = useState();

  const [ajout, setajout] = useState(false);
  const [data, setdata] = useState([]);
  const [listuser, setlistuser] = useState([]);

  const [user_selected, setuser_selected] = useState([])
  const [mois_selected, setmois_selected] = useState('Janvier')
  const [dateP, setdateP] = useState()
  const [societe, setsociete] = useState()
  const [mois_virement, setmois_virement] = useState()


  const [list_virement, setlist_virement] = useState([])
  const [virement, setvirement] = useState()
  const [listjournal, setlistjournal] = useState([])
  const [Totaljournal, setTotaljournal] = useState({})

  const [JP, setJP] = useState(false)

  const [prime, setprime] = useState({ prime: false, moisplus: false, libelle: '' })
  useEffect(() => {
    getEntrepriseByCode().then((res) => {
      setsociete(res.data)
    })

  }, [])

  useEffect(() => {
    const fetchLesMoisDuPaie = async () => {
      try {
        const res = await getlesmoisdupaie();
        const data = res.data;
        const groupedExercice = _.groupBy(data, 'exercice');
        setGroupedData(groupedExercice);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchLesMoisDuPaie();
  }, []);
  useEffect(() => {
    if (!prime.prime, groupedData && exercice_selectionne) {
      const last_element = groupedData[exercice_selectionne]?.slice(-1)[0];
      const month_index = listmois?.findIndex(item => item === last_element?.mois);
      setmois_selected(listmois[month_index + 1])
    }


  }, [groupedData, exercice_selectionne])
  useEffect(() => {
    getExercice().then((res) => {
      if (Array.isArray(res?.data)) {
        setexercice_selectionne(res?.data[0]?.id)
        const findprecedent = res.data.find(item => item.precedent === 1)
        setexercice_precedent(findprecedent)
        setExercice(res.data);
        const date = res.data[0].code_exercice + '-' + '01'
        setdateP(date)
      }

    });
  }, []);

  const get_Paie = (item, month) => {
    let mois = listmois.findIndex(item => item === month) + 1;
    mois = mois < 10 ? `0${mois}` : mois;
    const select_exercice = exercice.find(item => item.id === exercice_selectionne);

    const date = `${select_exercice?.code_exercice}-${mois}`;
    const p = item?.status === 'prime' ? { prime: true, libelle: item.prime } : item?.status === 'moisplus' ? { prime: true, moisplus: true, libelle: item.prime } : null
    history.push({
      pathname: `/admin/MatricePaie/`, state: { user_selected: user_selected, date: date, exercice: exercice_selectionne, prime: p }
    });
  };
  const handleChangeDate = (month) => {
    const select_exercice = exercice.find(item => item.id === exercice_selectionne);

    if (mois.includes(month)) {
      setprime({ prime: false, moisplus: false, libelle: '' })
      setmois_selected(month)
      let mois = listmois.findIndex(item => item === month) + 1;

      mois = mois < 10 ? `0${mois}` : mois;

      const date = `${select_exercice?.code_exercice}-${mois}`;
      setdateP(date)
    } else {
      const now = new Date();

      const mois = String(now.getMonth() + 1).padStart(2, '0');

      month === "prime" ? setprime({ prime: true, libelle: '' }) : setprime({ prime: true, moisplus: true, libelle: month })
      const date = `${select_exercice?.code_exercice}-${mois}`;
      setdateP(date)
      setmois_selected(month)
    }

  };

  const handleChangeexercice = (value) => {
    setexercice_selectionne(parseInt(value))
    let mois = dateP.split('-')[1]

    const select_exercice = exercice.find(item => item.id === parseInt(value));

    const date = `${select_exercice?.code_exercice}-${mois}`;

    setdateP(date)
  };
  const getData = () => {
    if (groupedData[exercice_selectionne] && groupedData[exercice_selectionne][groupedData[exercice_selectionne].length - 1].c === 0) {
      toast.warning(t("le dernier mois n'est pas clôturé"))
    } else {
      getUsersByCode()
        .then((res) => {
          setdata(res.data);
          setlistuser(res.data)
          setajout(true)
          const select_exercice = exercice.find(item => item.id === exercice_selectionne);
          const findindex = listmois.findIndex(item => item === mois_selected)
          const i = findindex + 1
          const month = i < 10 ? '0' + i : i
          const date = `${select_exercice?.code_exercice}-${month}`;

          setdateP(date)

        })
    }

  };
  const selectionall = () => {

    const alldata = data.map(item => item.id)
    setlistuser(data)
    setuser_selected(alldata)
  }


  const select_user = (userid) => {
    const findindexuser = user_selected.findIndex(item => item === userid);
    if (findindexuser !== -1) {
      const list = [...user_selected];
      list.splice(findindexuser, 1);
      setuser_selected(list);
    } else {

      setuser_selected((prev) => [...prev, userid])

    }
  }

  const cloturer = (valcloture, mois, status, prime) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Voulez-vous cloturer le paie "),
      icon: "warning",
      buttons: {
        cancel: t("Annuler"),
        confirm: {
          text: t("OK"),
          value: true,
        },
      },
      dangerMode: true,
    }).then((res) => {
      if (res) {
        const year = dateP.split('-')[0];

        const data_cloture = { mois: mois, year: year, status: status, prime: prime, cloture: valcloture, code_generated: localStorage.getItem('code_generated') }
        cloturerpaie(data_cloture).then((rescloturer) => {
          if (rescloturer.status === 200) {

            toast.success(t("Le paiement a été  clôturé"))
            window.location.reload()


          } else {
            toast.error(t('Un problème était produit'))

          }


        })
      }
    });
  }

  const handleSearch = (e) => {
    const dataSearch = filterUserByWord(data, e.target.value);
    setlistuser(dataSearch);
  };
  const dupliquer_paie = async (item) => {
    const index_mois = listmois.findIndex(e => e === item.mois);

    const last_mois = listmois[index_mois]


    if (item.c === item.count) {
      const data = { mois: item.mois, annee: item.annee, nouvelle_mois: mois_selected, last_mois: last_mois, code_generated: localStorage.getItem('code_generated') }
      const res = await dupliquerpaie(data)
      if (res.status === 200) {
        window.location.reload()
      }
    } else {
      toast.warning("le paie n'est ne pas clôturer")
    }

  }

  const getOrder_virement = (item) => {
    setJP(false)
    setvirement(true)
    setmois_virement(item.mois)
    setprime(item?.status === 'prime' ? { prime: true, libelle: item.prime } : item?.status === 'moisplus' ? { prime: true, moisplus: true, libelle: item.prime } : { prime: false, libelle: '' })
    getinfovirement(item.mois, item.annee, item.status, item.prime).then((res) => {
      setlist_virement(res?.data || [])

    })
  }


  const generateJournal = async (item) => {
    if (!dateP) return null;

    setmois_virement(item.mois);
    setprime(
      item?.status === "prime"
        ? { prime: true, libelle: item.prime }
        : item?.status === "moisplus"
          ? { prime: true, moisplus: true, libelle: item.prime }
          : { prime: false, libelle: "" }
    );

    const users = (await getuser_personnel(dateP)).data;
    const res = await getPaie(item.mois, null, item.annee, item.status, item.prime);

    if (res.status !== 200 || res.data?.data?.success === 0) {
      toast.error(res.data?.data.message);
      return null;
    }

    let nouvelleListe = [];

    res.data.listpaie.forEach((paiement) => {
      const utilisateur = users?.find(
        (u) => Number(u.code) === Number(paiement.id_users)
      );
      if (!utilisateur) return;

      // ---- calcul retenues ----
      const totalRetenue = paiement.paie_ligne?.reduce((acc, curr) => {
        if (curr.champs !== "retenue") return acc;
        if (curr.presence === 1) {
          return acc + (curr.valeur_annuel
            ? (curr.valeur_annuel / paiement.nb_s) * paiement.total
            : curr.valeur_mensuel * paiement.total);
        }
        return acc + (curr.valeur_annuel
          ? curr.valeur_annuel / paiement.nb_s
          : parseFloat(curr.valeur_mensuel));
      }, 0);

      const obj = {
        mois: item.mois,
        code: utilisateur.code,
        nom: utilisateur.nom,
        prenom: utilisateur.prenom,
        matricule_user: utilisateur.matricule_user,
        salbrut: formatFloat(paiement.salaire_brut),
        cnss: formatFloat(paiement.retenue_cnss),
        imposable: formatFloat(paiement.salaire_imposable),
        irpp: formatFloat(paiement.calcul_irpp_mois),
        css: formatFloat(paiement.calcul_irpp_css_mois - paiement.calcul_irpp_mois),
        deductionassurance: paiement.deductionassurance.toFixed(3),
        netapayer: formatFloat(paiement.net_servi_avant_arrondi),
        netapayerarrondi: formatFloat(paiement.net_a_payer),
        totalretenu: totalRetenue,
      };

      if (!nouvelleListe.find((u) => u.code === obj.code)) {
        nouvelleListe.push(obj);
      }
    });

    // Sort list
    nouvelleListe.sort((a, b) => Number(a.matricule_user) - Number(b.matricule_user));

    // ---- total ----
    const sum = (key) =>
      formatFloat(
        nouvelleListe.reduce((acc, item) => acc + parseFloat(item[key] || 0), 0)
      );

    const total = {
      mois: nouvelleListe[0]?.mois || "",
      code: "",
      nom: "",
      prenom: "",
      matricule_user: "",
      salbrut: sum("salbrut"),
      cnss: sum("cnss"),
      imposable: sum("imposable"),
      irpp: sum("irpp"),
      css: sum("css"),
      deductionassurance: sum("deductionassurance"),
      netapayer: sum("netapayer"),
      netapayerarrondi: sum("netapayerarrondi"),
      totalretenu: sum("totalretenu"),
    };

    return { nouvelleListe, total };
  };

  const journal_paie = async (item) => {
    const data = await generateJournal(item);
    if (!data) return;

    setlistjournal(data.nouvelleListe);
    setTotaljournal(data.total);
    setvirement(false);
    setJP(true);

    downloadPDF(data.nouvelleListe, data.total);
  };
  const journal_paie_excel = async (item) => {
    const data = await generateJournal(item);
    if (!data) return;

    exportExcelJournal(data.nouvelleListe, data.total);
  };

  const exportExcelJournal = (liste, total) => {
    if (!liste || liste.length === 0) return;

    // 🔹 Construire les lignes du fichier Excel
    const rows = liste.map(item => ({
      Nom: item.nom,
      Prénom: item.prenom,
      Matricule: item.matricule_user,
      "Salaire Brut": item.salbrut,
      CNSS: item.cnss,
      Imposable: item.imposable,
      IRPP: item.irpp,
      CSS: item.css,
      "Total Retenue": item.totalretenu,
      "Déduction Assurance": item.deductionassurance,
      "Net à Payer": item.netapayer,
      "Net à Payer Arrondi": item.netapayerarrondi,
    }));

    // 🔹 Ajouter la ligne TOTAL
    rows.push({
      Nom: "",
      Prénom: "",
      Matricule: "",
      "Salaire Brut": total.salbrut,
      CNSS: total.cnss,
      Imposable: total.imposable,
      IRPP: total.irpp,
      CSS: total.css,
      "Total Retenue": total.totalretenu,
      "Déduction Assurance": total.deductionassurance,
      "Net à Payer": total.netapayer,
      "Net à Payer Arrondi": total.netapayerarrondi,
    });

    // 🔹 Convertir en feuille Excel
    const ws = XLSX.utils.json_to_sheet(rows);

    // 🔹 Largeur des colonnes
    ws["!cols"] = [
      { wch: 18 }, // nom
      { wch: 18 }, // prénom
      { wch: 14 }, // matricule
      { wch: 14 }, // salaire brut
      { wch: 10 }, // cnss
      { wch: 12 }, // imposable
      { wch: 10 }, // irpp
      { wch: 10 }, // css
      { wch: 16 }, // total retenu
      { wch: 20 }, // deduction assurance
      { wch: 14 }, // net payer
      { wch: 18 }, // net payer arrondi
    ];

    // 🔹 Créer un classeur
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Journal Paie");

    // 🔹 Convertir en blob et télécharger
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], { type: "application/octet-stream" });

    const fileName = `Journal_Paie_${liste[0].mois}.xlsx`;
    saveAs(file, fileName);
  };

  const downloadPDF = () => {
    // Find the active tab pane
    const activeTabPane = document.getElementById('journalpaie');

    if (activeTabPane) {
      // Use html2canvas to capture the content of the active tab pane
      html2canvas(activeTabPane)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          const imgWidth = 210; // A4 size width in mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
          pdf.save('fiche_paie_.pdf');
        });
    } else {
      console.error('No active tab pane found.');
    }
  };

  const reportimpot = () => {

  }

  return (
    <div>
      <h1>{t('Liste de paies')}</h1>
      <div className="card">
        <div className="card-body">
          <div className="col-3 ">
            <select className="form-control" onChange={(e) => handleChangeexercice(e.target.value)}>
              {exercice.map((item, index) => (
                <option value={item.id} key={index}>
                  {item.code_exercice}
                </option>

              ))}
            </select>

          </div>




          <table className="mt-5 mb-5 table  table-vcenter text-nowrap table-bordered border-top border-bottom" id="hr-attendance">

            <thead>
              <th>{t('Mois')}</th>
              <th>{t('Somme net a payer')}</th>

              <th>{t('Etat')}</th>
              <th>{t('Order de Virement ')}</th>
              <th colSpan={2}>{t('Journal de paie ')}</th>
              <th></th>


            </thead>
            <tbody>
              {groupedData[exercice_selectionne] && groupedData[exercice_selectionne].length !== 0 && (groupedData[exercice_selectionne]?.map((item, index) => (
                <tr>
                  <td onClick={() => get_Paie(item, item?.mois)}>{item?.status === 'prime' ? item?.prime + '-' + item?.mois : item?.status === 'moisplus' ? item?.prime : item?.mois}</td>
                  <td>{item?.sum_net?.toFixed(3)}</td>

                  <td>{item?.c === 0 ? <strong style={{ color: 'red' }} onClick={() => cloturer(1, item?.mois, item?.status, item?.prime)}>{t('non cloturer')}</strong> : <strong style={{ color: 'green' }} onClick={() => cloturer(0, item?.mois, item?.status, item?.prime)}>{item?.c < item?.count ? 'partiellement cloturé' : 'cloturé'}</strong>} </td>
                  {item?.c === item?.count ? <td className='lien' onClick={() => getOrder_virement(item)}>Order de virement</td> : <td></td>}
                  {item?.c === item?.count ? <td className='lien' onClick={() => journal_paie(item)}>Journal de paie</td> : <td></td>}
                  {item?.c === item?.count ? <td className='lien' onClick={() => journal_paie_excel(item)}>Journal de paie (excel)</td> : <td></td>}

                  {index !== groupedData[exercice_selectionne].length && <p onClick={() => dupliquer_paie(item)} style={{ fontSize: '15px' }}><FaCopy /></p>}
                </tr>


              )))}
            </tbody>
          </table>
          <button
            className="btn btn-primary float-right"
            onClick={() => {
              ajout ? setajout(false) : getData();
            }}
          >

            <i className="far fa-credit-card" /> {ajout ? 'fermer' : "Ajouter"}
          </button>
          <div>
            {ajout && (
              <>
                <div className='row'>

                  <select
                    className="form-control col-4"
                    value={mois_selected}
                    onChange={(e) => handleChangeDate(e.target.value)}
                  >
                    {listmois.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}

                  </select>
                  {(prime.prime || prime.moisplus) &&
                    <>

                      <input
                        className="form-control col-2"
                        type="month"
                        value={dateP}
                        onChange={(e) => {
                          setdateP(e.target.value)
                        }}
                      />

                      <input
                        className="form-control col-2"
                        type="text"
                        value={prime.libelle}
                        placeholder={t("libelle de prime ")}

                        onChange={(e) => {
                          setprime(prev => ({
                            ...prev,
                            libelle: e.target.value
                          }))
                        }}
                      />

                    </>

                  }
                  <div className='col-2'>
                    <input
                      type="search"
                      className="form-control"
                      placeholder={t("Recherche...")}
                      aria-controls="hr-table"
                      onChange={handleSearch} />
                  </div>
                  <div className='col-2'>
                    {user_selected.length === 0 ? (
                      <p className="pointer link" onClick={selectionall}>
                        {t('Sélection tout')}
                      </p>
                    ) : (
                      <p className="pointer link" onClick={() => setuser_selected([])}>
                        {t('Désélectionné')}
                      </p>
                    )}
                  </div>
                </div>




                {listuser.map((item) => (
                  <div className="d-flex" key={item.id}>
                    <input
                      type="checkbox"
                      onClick={() => select_user(item.id)}
                      checked={user_selected.includes(item.id)} />
                    <ImageComponent atr="avatar avatar-md brround mr-3" picture={item.img} />
                    <div className="mr-3 mt-0 mt-sm-2 d-block">
                      <h6 className="mb-1 fs-14">
                        {item.nom} {item.prenom}
                      </h6>
                    </div>
                  </div>
                ))}

                <Link
                  to={{
                    pathname: '/admin/MatricePaie/',
                    state: { user_selected: user_selected, date: dateP, exercice: exercice_selectionne, exercice_precedent: exercice_precedent, prime: prime.prime ? prime : null }
                  }}

                  className="btn btn-primary float-right ml-2"
                >
                  {t('Calcul de paie')}
                </Link>
                {mois_selected === 'Janvier' && !prime?.prime &&
                  <Link
                    to={{
                      pathname: '/admin/reportimpot/',
                      state: { user_selected: user_selected, date: dateP, exercice: exercice_precedent, exercice_selectionne: exercice_selectionne }
                    }}

                    className="btn btn-primary float-right ml-2"
                  >
                    {t('Report impot')}
                  </Link>}

              </>
            )}

          </div>

        </div>
      </div>
      {virement && (
        <>
          <div onClick={() => setvirement(false)}><IoIosCloseCircle /></div>
          <PDFViewer style={{ width: "100%", height: "800px" }}>
            <OrdreVirement societe={societe} t={t} mois={mois_virement} year={exercice?.find(item => item.id === exercice_selectionne)?.code_exercice} list={list_virement} prime={prime} />
          </PDFViewer>
        </>
      )
      }
      {JP && (
        <PDFViewer style={{ width: "100%", height: "800px" }}>
          <Journalpaie list={listjournal} total={Totaljournal} societe={societe} mois={mois_virement} year={exercice?.find(item => item.id === exercice_selectionne)?.code_exercice} prime={prime} />
        </PDFViewer>
      )
      }


    </div>

  );
};
